// extracted by mini-css-extract-plugin
module.exports = {"required":"RequiredTip_required__cH4En","required__text":"RequiredTip_required__text__Qtb0s","required__star":"RequiredTip_required__star__BFqyV"};